export default {
  'not_found.title': 'This page has not been generated',
  'not_found.description': 'Tell me more about this page, so I can generate it',
};
